import { MouseEventHandler, RefObject } from 'react';

import { EBookingStatus } from 'types';

export interface HostGroup {
  id: number;
  title: string;
}

export interface Host {
  id: number;
  alias: string;
  position: number;
  group_id: number;
  client_sessions: {
    started_at: string;
    finished_at: string;
    time_left: number;
    id: number;
  }[];
  user?: {
    uuid: string;
    nickname: string;
    phone: string;
  };
}

export interface IBooking {
  id: number;
  hostIds: Array<number>;
  byClient: boolean;
  client?: {
    uuid: string;
    nickname: string;
    phone: string;
  };
  from: string;
  to: string;
  status: EBookingStatus;
  group: string;
  comment?: string | null;
}

export interface IHostBooking extends Omit<IBooking, 'byClient'> {
  host: {
    id: number;
    alias: string;
  };
  type: ESessionType;
}

export enum ESessionType {
  BOOKING = 'BOOKING',
  ONLINE_BOOKING = 'ONLINE_BOOKING',
  CLIENT_SESSION = 'CLIENT_SESSION',
}

export interface IBookingsRequest {
  from: string;
  to: string;
}

export interface IBookingsResponse {
  getBookings: {
    data: Array<IBooking>;
  };
}

export interface IHostGroupsResponse {
  hostGroupsOverview: Array<HostGroup>;
  hostsOverview: Array<Host>;
}

export interface IScrollState {
  isScrolling: boolean;
  clientX: number;
  clientY: number;
  startX: number;
  totalDistance: number;
  isAtEdge: boolean;
  edgeStartX: number;
  readyToSwitchDay: boolean;
  edgeSide: EdgeDirection | null;
}

export interface IReturnValue {
  ref: RefObject<HTMLDivElement>;
  onMouseDown: MouseEventHandler;
  onMouseMove: MouseEventHandler;
}
export type EdgeDirection = 'left' | 'right';

export interface IUseDragScrollProps {
  onSwipeLeftEdge?: () => void;
  onSwipeRightEdge?: () => void;
  minSwipeDistance?: number;
  onEdgeSwipeProgress?: (side: EdgeDirection, progress: number) => void;
}
